export default __webpack_public_path__ + "static/media/grapefruit-carousel-headline-box.8dca79d4.png";